export const PAYMENT_STATUS = {
  PAID: "paid",
  ACTIVE: "active",
  UNPAID: "unpaid",
  CANCELED: "canceled",
  PAST_DUE: "past_due",
}
